@if (auth.isLoading()) {
  <div class="flex items-center justify-center h-screen">
    <p>{{ "common.loading" | translate }}</p>
  </div>
} @else {
  <router-outlet />
}

<ng-toast />

<app-loading-overlay [detectRouteTransitions]="true" />
